import { useSyncExternalStore } from "react";
import {
  DEFAULT_SETTINGS,
  getSnapshot,
  subscribe,
  type Settings,
} from "@/engine/state/settings";

/**
 * The React seam over `src/engine/state/settings.ts`. It re-exports
 * nothing on purpose, so a non-React caller cannot reach the store through a
 * hook module.
 */
export function useSettings(): Settings {
  return useSyncExternalStore(subscribe, getSnapshot, () => DEFAULT_SETTINGS);
}
